import * as yup from 'yup';
import { staticDataHelper } from '../../../config';

const loginCodeLength = staticDataHelper.loginCodeLength;
const loginCodeRegEx = new RegExp(`[0-9]{${loginCodeLength}}`);

export const loginCodeValidationSchema = yup.object().shape({
  loginCode: yup
    .string()
    .matches(loginCodeRegEx, `Please enter your ${loginCodeLength}-digit login code`)
    .required(`Please enter your ${loginCodeLength}-digit login code`),
});
